<template lang="pug">
  v-container.login.pa-0.heigth-100(fluid)
    v-row.align-center
      v-col.d-none.d-md-flex.heigth-100(cols="5")
        v-img.heigth-100(:src="img.background_login")
      v-col.pt-10(cols="12" md="7")
        v-row.flex-column.align-center.mt-10.mt-sm-auto.px-10.text-center
          v-img( :src="img.logo" max-width="213")
          h1.mt-5 #[translate Disposables Configurator]
          p.primary--text.font-weight-light.subtitle #[translate Find the right material with the properties you are looking for!]
          v-img.my-3(:src="img.ue")
          //- span.opacity-50.mt-5.disposable_gray--text #[translate .]
          .blockError
            p.pt-5(v-if="errorMsg") {{errorMsg}}
          form#form_restore.mt-5(v-if="!restoreSend && (isCorrectToken || isReset )")
            div.margin-bottom-32
              v-text-field.field-login(v-model="password" :label="placeholder.pwd" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" @focus="resetError()")
            div.margin-bottom-32
              v-text-field.field-login(v-model="passwordConfirm" :label="placeholder.pwdConfirm" :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'" :type="showPasswordConfirm ? 'text' : 'password'" @click:append="showPasswordConfirm = !showPasswordConfirm" @focus="resetError()")
            div.text-center
              v-btn.btn-app.mb-0(v-if="isCorrectToken" color="primary" type="button" width="167" height="45" @click="restore" @keyup.enter="restore" :disabled="password && password !== passwordConfirm") #[translate Save your password]
              v-btn.btn-app.mb-0(v-if="isReset" color="primary" type="button" width="167" height="45" @click="restore" @keyup.enter="restore" :disabled="password && password !== passwordConfirm") #[translate Change password]
          v-row.mt-15(v-if="restoreSend")
            v-col.text-center(cols="12")
              v-img.mx-auto.mb-5(:src="img.smile" width="20" height="20" )
              p.mb-10 #[translate Password created.]
          v-btn.btn-app.mb-0.mt-15(v-if="restoreSend" color="primary" type="button" width="167" height="45" @click="goLogin") #[translate Go login]
          p.mt-15.copy #[translate Copyright © 2021 INPACS GmbH]
</template>

<script>
import SrvLogin from '@/services/login.js';

export default {
  name: 'reset',
  data() {
    return {
      password:'',
      passwordConfirm:'',
      token:'',
      isCreated: false,
      isReset: false,
      restoreSend: false,
      showPassword: false,
      showPasswordConfirm: false,
      errorMsg: '',
      isCorrectToken: false,
      img: {
        background_login: require('@/assets/img/login/fondo_login.png'),
        ue: require('@/assets/img/login/EU_directive.png'),
        logo: require('@/assets/img/logo.png'),
        smile: require('@/assets/img/login/smile.png'),
      },
      email: null,
      placeholder: {
        'pwd': this.$gettext('Password'),
        'pwdConfirm': this.$gettext('Confirm password'),
      },
      //page_password_reset: this.$config.page_password_reset,
      RememberCheck: false,
      inviteOk: false
    }
  },
  created() {
    if(this.$route.query.confirm) {
      this.isCreated = true
      this.token = this.$route.query.confirm
    } else if(this.$route.query.token) {
      this.isReset = true
      this.token = this.$route.query.token
    }
    if (this.isCreated) {
      this.sendConfirm(this.token)
    }
  },
  components: {
  },
  methods: {
    resetError () {
      this.errorMsg = ''
    },

    restore () {
      SrvLogin.changePassword({token : this.token, password: this.password})
        .then(res => {     
          this.restoreSend = res.data.status === 'OK' ? true : false
        }, (error) => {
          this.errorMsg = error.data.password ? error.data.password[0] : 'error' 
        })
    },
    goLogin () {
      this.$router.push({name: 'home'})
    },
    sendConfirm (token) {
      SrvLogin.sendConfirm(token)
        .then(res => {
          console.log(res)
          this.isCorrectToken = true
        }, (error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" >
  .heigth-100{
    height: 100vh;
  }
  .login{
    h1{
      font-family: 'Roboto Slab';
      font-size: 28px;
      color: #003A70;
      font-weight: bold;

    }
    .subtitle{
      font-size: 20px;
    }
    .blockError{
      height: 10px;
      p{
        color:#EC4444
      }
    }
    #form_restore{
      width:100%;
      max-width: 360px;
      .field-login{
        .v-label{
          font-size: 15px;
          color: var(--v-disposable_gray-base);
        }
        input{
          font-size: 15px;
        }
      }

    }

    .copy{
      font-size: 10px;
    }
  }

</style>